<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Items from '../components/Items.svelte';
    import {location, querystring} from 'svelte-spa-router';
    import Loader from '../components/Loader.svelte';

    import Pagination from '../components/Pagination.svelte';
    import { current_component } from 'svelte/internal';

    export let params = {}

   
    let totalItems = 0; 
    let itemsPerPage = 0; 
    let currentPage = 0;
    if (params.page) {
        currentPage = parseInt(params.page);
    }

   
    let items = [];  
    let filters = {}; 
    let categories = [];
    let popup = false;
    let searchTerm = '';
    let categorySearchTerm = '';
    let priceFrom = '';
    let priceTo = '';
    let feeTo = '';
    let feeFrom = '';
    let category = '';
    let new_category_value = '';
    let is_loading = false;



    function getQueryParam() {
       
        let params = [''];
        if (window.location.href.includes("?")) {
            params = window.location.href.split("?").reverse();
        }
        const urlParams = new URLSearchParams(params[0]);

        let temp_filters = {}

        for (const [key, value] of urlParams.entries()) {

            temp_filters[key] = value;
        }

        return temp_filters;
    }

    function setQueryParam(paramName,paramValue) {

        let params = [''];
        if (window.location.href.includes("?")) {
            params = window.location.href.split("?").reverse();
        }

        const urlParams = new URLSearchParams(params[0]);
        urlParams.set(paramName, paramValue);                
        const newUrl = `#${$location}?${urlParams.toString()}`;        
        history.replaceState(null, '', newUrl);      
        

    }

    
    onMount(async() => {

        if ($UserStore.manager==1) {
            push('/customers');
        }


        filters = getQueryParam()
        for(var key in filters) {
            if (key=='pricefrom') {
                priceFrom = filters[key]
            }
            if (key=='priceto') {
                priceTo = filters[key]
            }
            if (key=='feefrom') {
                feeFrom = filters[key]
            }
            if (key=='feeto') {
                feeTo = filters[key]
            }
            if (key=='search') {
                searchTerm = filters[key]
            }
            if (key=='category') {
                category = filters[key]
            }
        }


        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.merchant_id){
            push('/login');
            return;
        }

        getProducts(filters)

        getCategories();    
        
        
    })

    const handleSubmit =  async () => {
        alert(1)
    }

    $: {

    //   categories_sync_filtered = categories_sync.filter(cat => {
    //     return cat.name.toLowerCase().includes(searchTerm.toLowerCase());
    //   });
    }

    async function getProducts(filters={}) {

        let postData = {};

        is_loading = true;


        postData.action = 'products';
        postData.token = $UserStore.token
        postData.filters = getQueryParam();
        postData.page = currentPage;
        postData.limit = 100;
        let response = await fetchData(postData);
        if (response.data) {            
            items = response.data;
            items = items.map((item)=>{
                //item.commision = (item.price - item.drop_price).toFixed(2);
                item.options = JSON.parse(item.options)
                return item;
            })

            console.log(totalItems)

            totalItems = response.count;

            console.log(totalItems)

            is_loading = false;

            // postData.action = 'filters';
            // postData.token = $UserStore.data
            // response = await fetchData(postData);
            // if (response.data) {
            //     filters = response.data
            // }

        }
    }

    async function getCategories() {

        let postData = {};

        postData.action = 'categories';
        postData.token = $UserStore.token
        let response = await fetchData(postData);
        if (response.success==1) {
            categories = response.data;
        }

    }

    async function filterProducts() {

        filters = getQueryParam()       
        getProducts(filters)

    }

    function closePopup() {
      popup = false;
    }

    function openCategoryBox(event) {

        popup = true;

    }

    const searchAction = ()=> {

        setQueryParam('pricefrom',priceFrom)
        setQueryParam('priceto',priceTo)
        setQueryParam('feefrom',feeFrom)
        setQueryParam('feeto',feeTo)
        setQueryParam('search',searchTerm)

        filterProducts();

    }


    function handlePageChange(page) {
        currentPage = parseInt(page);
        console.log('Current Page:', currentPage);

        let params = '';
        if (window.location.href.includes("?")) {
            params = window.location.href.split("?").reverse();
        }

        let push_string = '/products/'+currentPage;

        if (params[0]) {
            push_string += '?' + params[0]
        }

        push(push_string)
        filterProducts();
    }

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list">  
            {#if is_loading}
                <Loader/>
            {/if}
            <div class="items-filters">
                <span>סינון</span>
            </div>
            <div class="items-filters">
                <div class="flex">
                    <button on:click={openCategoryBox}>קטגוריות</button>
                    {#if category !=''}
                        <span class="remove"><span on:click={ () => { category =''; setQueryParam('category',''); }}>x</span> {category}</span>
                    {/if}
                </div>
                <div>
                    <span>לפי מחיר</span>
                    <input type="number" placeholder="ממחיר" bind:value={priceFrom}>
                    <input type="number" placeholder="עד מחיר" bind:value={priceTo}>
                </div>
                <div>
                    <span>לפי עמלה</span>
                    <input type="number" placeholder="מסכום" bind:value={feeFrom}>
                    <input type="number" placeholder="עד סכום" bind:value={feeTo}>
                </div>
                <div>
                    <span>חיפוש חופשי</span>
                    <input type="text" placeholder="חיפוש" class="search" bind:value={searchTerm}>
                </div>
                <div>
                    <button on:click={searchAction}>חיפוש</button>
                </div>

            </div>      
            <Items {items} {filters}/>
            <Pagination
                {totalItems}
                {itemsPerPage}
                {currentPage}
                onPageChange={handlePageChange}
                />
        </div>

        {#if popup}
        <div class="popup">
            <div class="popup_close" on:click={closePopup}>x</div>
            <div>
              <input type="text" bind:value={categorySearchTerm}>
            </div>
            {#if categories}
              {#each categories as cat} 
                <span class="sync_cat" on:click={() => { category = cat.name; setQueryParam('category',cat.name);   }}>{cat.name}</span>
                {#each cat.children as cat_child} 
                    <span class="sync_cat" on:click={() => { category = cat_child.name; setQueryParam('category',cat_child.name);  }}>{cat.name} > {cat_child.name}</span>
                    {#each cat_child.children as cat_child2} 
                    <span class="sync_cat" on:click={() => { category = cat_child2.name; setQueryParam('category',cat_child2.name);  }}>{cat.name} > {cat_child.name} > {cat_child2.name}</span>
                    {/each}
                {/each}
              {/each}
            {/if}
        </div>
        {/if}

    </div>
</div>

<style>   
    .remove {
        padding: 2px;
        background-color: rgb(205, 216, 255);
        border-radius: 2px;
        /* color: #fff; */
        font-size: 12px;
        padding: 5px;
        margin: 3px;
        display: inline-block;
        cursor:default;
    }
    .remove > span{
        border-radius: 50%;
        background-color: #6c79a7;
        width: 18px;
        display: inline-block;
        color: #fff;
        text-align: center;
        cursor: pointer;
    }
    .flex {
        display: flex;
    }
    .items-filters button{

        background-color: var(--blue-color);
        border-radius: 30px;
        color: #fff;
        border: 1px solid #eee;
        padding: 5px 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        width: auto;
        font-size: 14px;
        
    } 
    .items-filters {
        background-color: #fff;
        padding:10px;
        display: flex;
        gap: 30px;
        font-size: 14px;
    }
    .items-filters input {
        padding: 5px;
        border-radius: 4px;
        width: 90px;
        border: 1px solid #c6c6c6;
    }
    .items-filters input.search {
        width:150px;
    }
    .orders-filters {
        display: relative;
        display: flex;
        margin-bottom:40px;
        gap:10px;
    }
    .orders-filters .date-field,
    .orders-filters select,
    .orders-filters input {
        border: 1px solid #eee;
        border-radius:30px;
        padding: 8px 20px;
        border: 3px solid rgb(244, 247, 249);
        font-size: 15px;;
        background-color: #fff;;
    
        border-radius: 30px;
        padding: 15px 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        width: auto;
        font-size: 14px;
    }
    
    
    .orders-filters .date-field .icon-calendar {
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEmSURBVHgB7ZcPzcIwEMUfXz4BSCgKwAGgACRMAg6YBBxsOMABOAAHFAXgAK5Z2Y6lHbfQ8SfpL3lZaY/1rb01N+BHUKSMNBfEJjZWISA56Uo6C2KvVpkgFn9oRx9vICFtUT1JKO3tvRtZdjBxXQs+YY+1FenIfuesPUGVVLzfRWKvmrSzbbN19wS+kAb2+sCEuUxrYzkbe4YvCVM2Vr5NPAkVa+van7Wn38U95uTpN5TJ/A8ZKemAakmbmJJGpI0gVmwA0huieFItjG19DgTHtwIZhCfZq3ztCuzQYh+FKBSvusjAGs8PnLYkLgMf34JoIBqIBqKBaIAb0Kw9RlhMCTbzzPWAqYq7LsuPaGDUsYmznaOk5zChUJTNQ4TFVMkrOL4HPsoNn26PxROHCggAAAAASUVORK5CYII=) no-repeat center center;
        background-size: 14px 14px;
        height: 14px;
        width: 14px;
    }
    .orders-filters > button {
        background-color: var(--blue-color) ;
        border-radius: 30px;
        color: #fff;
        border: 1px solid #eee;
        padding: 15px 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        width: auto;
        font-size: 14px;
    }
    .orders-top-up {
        display: flex;
        justify-content: space-between;
    }
    .create_button {
    
        background-color: var(--blue-color) ;
        border-radius: 30px;
        color: #fff;
        border: 1px solid #eee;
        padding: 15px 30px;
        cursor: pointer;
        display: flex;
        align-items: center;
        width: auto;
        font-size: 14px;
    }
    
    
    .popup_close {
        background-color: var(--blue-color);
        color: white;
        display: inline-block;
        padding-top: 5px;
        border-radius: 50%;
        position: absolute;
        top: 5px;
        left: 5px;
        width: 30px;
        height: 25px;
        text-align: center;
        line-height: 18px;
        cursor: pointer;
      }
      .popup {
        position: fixed;
        top:20px;
        padding:20px;
        right:0;
        left:0;
        margin: auto;
        width:600px;
        background-color: white;
        z-index: 1;
        box-shadow: 0 0 10px 5px rgb(227, 227, 227);
        border-radius: 10px;;
        max-height: 300px;
        overflow-y: scroll;
      }
      .sync_cat {
        padding:5px;
        margin: 5px;;
        background-color: rgb(205, 216, 255);
        border-radius: 2px;
        display: inline-block;
        font-size: 12px;
      }
    
    
</style>